<template>
	<div class="newList">
		<template v-if="headerShow">
			<div class="newListFor" v-for="(item,index) in list" :key="index" @click="goDetail(item)">
				<div class="newListForImg">
					<img :src="item.cover" />
				</div>
				<div class="newListForWz">
					<div class="newListForWzName">
						{{item.title}}
					</div>
					<div class="newListForWzCen">
						{{item.desc}}
					</div>
					<div class="newListForWzTime">
						{{item.publish_time}}
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="newListFor" v-for="(item,index) in list" :key="index" @click="goDetail(item)">
				<div class="newListForImg">
					<img :src="item.cover" />
				</div>
				<div class="newListForWz">
					<div class="newListForWzName">
						{{item.title}}
					</div>
					<div class="newListForWzCen">
						{{item.desc}}
					</div>
					<div class="newListForWzTime">
						{{item.publish_time}}
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Array,
				default: ''
			}
		},
		data() {
			return {

			}
		},
		mounted() {

		},
		methods: {
			goDetail(e) {
				this.$router.push({
					path: "/newsDetail",
					name: 'newsDetail',
					query: {
						id: e.id
					}
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.newList {
		width: 1200px;
		margin: 0 auto;
		padding-top: 172px;

		.newListFor:hover {
			img {
				transform: scale(1.1);
			}
		}

		.newListFor:first-child {
			border-top: 2px solid #E5E5E5;
			padding-top: 54px;
		}

		.newListFor {
			cursor: pointer;
			padding-bottom: 54px;
			margin-bottom: 54px;
			border-bottom: 2px solid #E5E5E5;
			display: flex;
			align-items: center;

			.newListForImg {
				width: 350px;
				height: 200px;
				overflow: hidden;
				margin-right: 20px;

				img {
					width: 100%;
					height: 100%;
					transition: all 0.3s ease-in-out;
				}
			}

			.newListForWz {
				flex: 1;
				width: 0;
				height: 200px;
				display: flex;
				flex-direction: column;

				.newListForWzName {
					// font-size: 26px;
					font-size: 24px;
					
					font-weight: bold;
					color: #000000;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.newListForWzCen {
					flex: 1;
					margin: 20px 0 20px;
					display: flex;
					align-items: center;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 4;
					// 必须加不然隐藏不了
					/*! autoprefixer: ignore next */
					-webkit-box-orient: vertical;
					font-size: 18px;
				}

				.newListForWzTime {
					font-size: 14px;
					
					font-weight: 400;
					color: #999;
				}
			}
		}
	}

	@media screen and (max-width:1200px) {
		.newList {
			width: 100% !important;
			padding-top: 30px !important;
			.newListFor{
				width: 100% !important;
				padding:10px 30px !important;
				margin-bottom: 0px !important;
				box-sizing: border-box;
				.newListForImg {
					width: 120px !important;
					height: 60px !important;
				}
				.newListForWz {
					box-sizing: border-box;
					height: auto !important;
					.newListForWzName{
						font-size: 16px !important;
						// width: calc(100vw - 60px);
					}
					.newListForWzCen{
						font-size: 14px !important;
						// width: calc(100vw - 60px);
					}
				}
			}
		}
	}
</style>